import React from "react"
import {Application, denyApplication, EntityDeclineReason, EvaluationOutcome} from "../../resources/application"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {Modal} from "../Modals/Modal"
import {refreshAndClose} from "../../utilities/modals"
import {ApplicationDenyContent, DenyConfig, getSingleEntityReasons} from "./ApplicationDeny"

function buildOnboardingDenyConfig(
	application: Application,
	accessToken: string,
	deny: (
		accessToken: string,
		application: Application,
		reason: string,
		reasons: EntityDeclineReason[],
		evaluatedAt?: Date
	) => void
): DenyConfig {
	const reasons = new Map<string, string[]>()
	const outcome = new Map<string, EvaluationOutcome>()

	const entityName = application.type == "individualApplication" ? "Individual" : "Business"

	if (application.type == "individualApplication" || application.type == "businessApplication") {
		outcome.set(entityName, application.attributes.evaluationOutcome)
		getSingleEntityReasons(
			reasons,
			entityName,
			application.attributes.evaluationCodes,
			application.attributes.evaluationOutcome
		)
	}
	if (application.type == "businessApplication") {
		if (!application.attributes.publicTradedCompany && application.attributes.officer) {
			outcome.set("Officer", application.attributes.officer.status)
			getSingleEntityReasons(
				reasons,
				"Officer",
				application.attributes.officer?.evaluationCodes,
				application.attributes.officer.status
			)
		}
		if (!application.attributes.publicTradedCompany && application.attributes.beneficialOwners) {
			application.attributes.beneficialOwners.forEach((bo) => {
				const boName = `Beneficial owner - ${bo.fullName.first} ${bo.fullName.last}`
				outcome.set(boName, bo.status)
				getSingleEntityReasons(reasons, boName, bo.evaluationCodes, bo.status)
			})
		}
	}

	return {
		initialReasons: reasons,
		evaluationOutcome: outcome,
		isMultiEntity: application.type === "businessApplication",
		entityName,
		denyFn: (reason, declineReasons) =>
			deny(accessToken, application, reason, declineReasons, application.attributes.updatedAt),
	}
}

export function DenyOnboardingApplicationModal({
	application,
	close,
	onSuccess,
	accessToken,
}: {
	application: Application
	close: () => void
	onSuccess: () => void
	accessToken: string
}) {
	const [state, deny] = useAsyncResultIdle(denyApplication)
	const config = buildOnboardingDenyConfig(application, accessToken, deny)

	return (
		<Modal classname="deny-application-modal" close={refreshAndClose(onSuccess, close)}>
			<ApplicationDenyContent config={config} onSuccess={refreshAndClose(onSuccess, close)} state={state} />
		</Modal>
	)
}
